import { render, staticRenderFns } from "./HistoryQuery.vue?vue&type=template&id=ab0dfa24"
import script from "./HistoryQuery.vue?vue&type=script&lang=js"
export * from "./HistoryQuery.vue?vue&type=script&lang=js"
import style0 from "./HistoryQuery.vue?vue&type=style&index=0&id=ab0dfa24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports